import { Signal } from '@preact/signals';

export const pausedListener = (videoPlaying: Signal<boolean>) => {
  videoPlaying.value = false;
};
